import { render, staticRenderFns } from "./MapType.vue?vue&type=template&id=6271c892&scoped=true"
import script from "./MapType.vue?vue&type=script&lang=js"
export * from "./MapType.vue?vue&type=script&lang=js"
import style0 from "./MapType.vue?vue&type=style&index=0&id=6271c892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271c892",
  null
  
)

export default component.exports